



























































import { Component, Vue } from 'vue-property-decorator';

import { getCurrentUser } from '@/app/shared/firebase/firebase-user';
import { UserProfileItem } from '@/app/shared/utilities/static-types';
import { UserProfileItemFactory } from '@/app/shared/utilities/object-factory';
import { logoutUserAction } from '@userApp/shared/actions';

import routesNames from '@/app/shared/utilities/routes-names';
import logoImage from '@/assets/images/Logo.png';
import landingLogo from '@/assets/images/landing-logo.png';
import namespace from '@/app/shared/store/namespace';
import LogoIcon from '@/app/shared/components/icons/LogoIcon.vue';
import PopupMessage from '@/app/shared/components/PopupMessage.vue';
import LocaleSwitcher from '@/app/shared/components/LocaleSwitcher.vue';

@Component({
  components: {
    LogoIcon,
    PopupMessage,
    LocaleSwitcher,
  },
})
export default class BottomNavigationBar extends Vue {
  public userLoggedIn = false;

  public userProfileItems: UserProfileItem[] = [];

  public showConfirmationMessage: (() => Promise<any>) | null = null;

  public homeRoute = routesNames.HOME;
  public isHome = false;

  public navigationItems = [
    {
      title: 'login',
      icon: 'power_settings_new',
      color: 'secondary',
      to: routesNames.LOGIN,
    },
  ];

  public async created() {
    const user = await getCurrentUser();
    this.userLoggedIn = Boolean(user);

    this.isHome = this.$route.name === this.homeRoute.name;

    this.userProfileItems = [
      UserProfileItemFactory('logout', undefined, async () => {
        try {
          await this.showConfirmationMessage!();
        } catch (err) {
          return;
        }

        try {
          await logoutUserAction();
          this.$store.commit(
            `${namespace.NavigationModule}/resetSystemFeatures`,
          );
          this.$router.replace(routesNames.HOME);
        } catch (err) {
          throw new Error('Failed to logout');
        }
      }),
    ];
  }
}
